import view from "./view";
import action from "./action";
import StateAction from "./state-action";
import {slideToggle, openModal, closeModal, slideCalendar, scrollWindow, flickCal} from "../modules/animation";
import store from "./store";
import {generateHashChangeHandler} from "./hash-control";
import setState from "../modules/set-state";

const events = store.events;

// ブラウザバックをレイヤーを閉じるアクションに紐付ける
window.onhashchange = generateHashChangeHandler(store.state);

/*
 * イベントの流れ
 * DOM Event(ユーザアクションなど) -> State(状態の変化) -> view (htmlレンダリング)
 */
store.$eventhub
	// DOM -> action (-> state)
	.on("ready", store, action.init)
	.on("click", ".forcia-go-detail", store, action.goDetail)
	.on("click", ".forcia-go-detail-without-date", store, action.goDetailWithoutDate)
	.on("click", ".forcia-go-detail-calendar", store, action.goDetailCalendar)
	.on("click", ".forcia-search-list", store, action.list)
	.on("click submit", ".forcia-state", store, setState)
	.on("click", ".forcia-count-close", store, action.countClose)
	.on("click", ".forcia-state-count", store, action.setStateCount)
	.on("click", ".forcia-close-hotel-layer", store, action.closeHotelLayer)
	.on("click", ".forcia-state-reset", store, action.resetConditions)
	.on("click", ".forcia-state-reset-budget", store, action.resetBudget)
	.on("click", ".forcia-state-reset-flight", store, action.resetFlight)
	.on("click", ".forcia-state-reset-kodawari", store, action.resetKodawari)
	.on("click", ".forcia-state-reset-hotel", store, action.resetHotel)
	.on("change click", ".forcia-state-search", store, action.setStateSearch)
	.on("change", ".forcia-review", store, action.reviewHotels)
	.on("click", ".forcia-mvcal", store, action.slideCalendar)
	.on("click", ".forcia-close-calendar", store, action.closeCalendar)
	.on("click", ".forcia-calendar-date", store, action.selectCalendarDate)
	.on("change", ".forcia-check-stock", store, action.checkStock)
	.on("change", ".forcia-check-month", store, action.checkMonth)
	.on("click", ".forcia-page", store, action.page)
	.on("change", ".forcia-check-hotel", store, action.checkReviewHotel)
	.on("click", ".forcia-page-review", store, action.reviewPage)
	.on("click", ".forcia-open-arrival", store, action.openArrival)
	.on("click", ".forcia-arrival", store, action.arrival)
	.on("click", ".forcia-open-course-calendar", store, action.openCourseCalendar)
	.on("focus", "#forcia-keyword-hotel", store, action.suggestHotel)
	.on("focus", "#forcia-freeword", store, action.suggestFreeword)
	.on("blur", ".ipt_txtBoxWrap", store, action.setStateCount)
	.on("click", ".forcia-clear-hotelname", store, action.clearHotelName)
	.on("click", ".forcia-clear-freeword", store, action.clearFreeword)
	.on("click", ".forcia-go-hotel-tours", store, action.goHotelTours)
	.on("click", ".forcia-picked-hotel", store, action.pickedHotel)
	.on("click", ".forcia-go-multi-hotel-tours", store, action.goMultiHotelTours)
	// state -> state
	.on(events("CalendarState"), store, StateAction.setCalendarCount)
	.on(events("ConditionState", "sort"), store, StateAction.setFirstPage)
	.on(events("hotels"), store, StateAction.setFirstReviewPage)
	.on(events("city0"), store, StateAction.uncheckDestOption)
	// state -> view
	.on(events("ListMobile"), store, view.listHtml)
	.on(events("HotelListMobile"), store, view.hotelListHtml)
	.on(events("RankingList"), store, view.ranking)
	.on(events("HistListMobile"), store, view.history)
	.on(events("courseCalendarLayer"), store, view.courseCalendar)
	.on(events("ConditionState"), store, view.departure)
	.on(events("ConditionState", "subLayer"), store, view.region0)
	.on(events("ConditionState", "subLayer"), store, view.country0)
	.on(events("ConditionState", "subLayer"), store, view.city0)
	.on(events("ConditionState", "subLayer"), store, view.country1)
	.on(events("ConditionState", "subLayer"), store, view.city1)
	.on(events("ConditionState"), store, view.kodawari)
	.on(events("ConditionState", "page"), store, view.dataCount)
	.on(events("ConditionState"), store, view.calendarDate)
	.on(events("page"), store, view.pager)
	.on(events("budget", "BudgetDurationState"), store, view.budget)
	.on(events("duration", "BudgetDurationState"), store, view.duration)
	.on(events("date", "calendarCount"), store, view.calendarMonth)
	.on(events("date", "_checkStock", "monthIndex"), store,  view.calendarCheckbox)
	.on(events("monthIndex"), store,  view.slideCalendar)
	.on(events("sort"), store, view.sort)
	.on(events("HotelMinPop", "HotelMaxPop"), store, view.reviewMinMax)
	.on(events("hotelname"), store, view.hotelName)
	.on(events("freeword"), store, view.freeword)
	.on(events("hotels", "reviewPage"), store,  view.hotels)
	.on(events("isOpenedLayer"), store,  view.currentConditions)
	.on(events("isOpenedLayer"), store, view.isOpenedLayer)
	.on(events("subLayer"), store, view.mainLayer)
	.on(events("subLayer"), store, view.subLayer)
	// Other events without state
	.on("click", ".forcia-slide-toggle", slideToggle)
	.on("click", ".forcia-open-modal", openModal)
	.on("click", ".modal_wrap", closeModal)
	.on("click", "#forcia-course-calendar .ipt_calBox_navItem a", slideCalendar)
	.on("click", ".forcia-scroll", scrollWindow)
	// enable flick
	.on(flickCal.events, ".ipt_calBox")
	.on("myflickprev", ".ipt_calBox", flickCal.prev)
	.on("myflicknext", ".ipt_calBox", flickCal.next)
	;



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/index.js